/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  ListsWidget2,
  // ListsWidget3,  
  // ListsWidget4,
  ListsWidget6,
  TablesWidget13,
  
  } from '../../../_metronic/partials/widgets'
import {TablesWidget15} from '../../../_metronic/partials/widgets/tables/TablesWidget15'
import {TablesWidget16} from '../../../_metronic/partials/widgets/tables/TablesWidget16'

const DashboardPage: FC = () => (
  <>
    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-12'>
        <TablesWidget13 className='card-xxl-stretch mb-5 mb-xl-8' />
      </div>
    </div>
    {/* 
    
     */}
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-12'>
        <TablesWidget15 className='card-xxl-stretch my-5' />
      </div>
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row mt-5 gy-5 gx-xl-8'>
      {/* <div className='col-xxl-4'>
        <ListsWidget2 className='card-xl-stretch mb-xl-8' />
      </div> */}
      {/* <div className='col-xxl-8'>
        <ListsWidget6 className='card-xl-stretch mb-xl-8' />
      </div> */}
      {/* <div className='col-xxl-4'>
        <ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' />
      </div> */}
    </div>
    {/* end::Row */}
  </>
)

const AdminDashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {'Admin ' + intl.formatMessage({id: 'MENU.DASHBOARD'})}
      </PageTitle>
      <DashboardPage />
    </>
  )
}

export {AdminDashboardWrapper}
